/*Funkcija za prikaz izraza z označenim iskalnim izrazom */
export const renderHighlightedPath = (
  path,
  searchKeyword,
  MIN_SEARCH_LENGTH,
) => {
  const keyword = searchKeyword.trim();

  if (!path || keyword.length < MIN_SEARCH_LENGTH) {
    return path;
  }

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escapedKeyword})`, "ig");

  return path.split(regex).map((part, index) => {
    if (part.toLowerCase() === keyword.toLowerCase()) {
      return (
        <span
          key={`${part}-${index}`}
          className="programs-page-search-results__highlight"
        >
          {part}
        </span>
      );
    }

    return <span key={`${part}-${index}`}>{part}</span>;
  });
};
